import { SearchTextInput } from '@frontend/components/basic-forms';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

interface SearchFilterProps {
    id?: string;
    filterValue?: (value: string) => void;
    placeholder?: string;
    label?: React.ReactNode | null;
    resetFilter?: boolean;
    className?: string;
}

export const SearchFilter = (props: SearchFilterProps) => {
    const intl = useIntl();
    const [filterValue, changeFilterValue] = useState<string | null>(null);

    useEffect(() => {
        if (props.resetFilter) {
            changeFilterValue('');
        }
    }, [props.resetFilter]);
    useEffect(() => {
        if (filterValue === null) return;
        const timeOutId = setTimeout(() => filter(filterValue), 300);
        return () => clearTimeout(timeOutId);
    }, [filterValue]);

    const filter = async (value: string) => {
        props.filterValue && props.filterValue(value);
    };

    return (
        <SearchTextInput
            className={props.className}
            id={props.id ? props.id : 'Search'}
            placeholder={props.placeholder ? props.placeholder : intl.formatMessage({ defaultMessage: 'Search', id: 'common.search', description: 'Search placeholder' })}
            value={filterValue}
            useConditionedStyling={false}
            onChange={changeFilterValue}
            submitted={false}
        />
    );
};
